import { isNullish } from 'shared/lib/is';

export interface QueryStringOptions {
  arraySerializer?: (arr: unknown[]) => string;
  skipNullish?: boolean;
}

const defaultArraySerializer: QueryStringOptions['arraySerializer'] = (arr) => arr.map(String).join(',');

export const toQueryString = (params: Record<string, unknown>, options: QueryStringOptions = {}): string => {
  const { arraySerializer = defaultArraySerializer, skipNullish = true } = options;

  return Object.entries(params)
    .flatMap(([key, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0 ? [`${encodeURIComponent(key)}=${encodeURIComponent(arraySerializer(value))}`] : [];
      }

      if (skipNullish && isNullish(value)) {
        return [];
      }

      return [`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`];
    })
    .join('&');
};
